export default class AbstractComponent {
  constructor(data = this.getDefaultData(), options = {}, ...extArgs) {
    this.data = data;
    this.options = Object.assign(this.getDefaultOptions(), options);
    this.extArgs = extArgs;
  }

  getDefaultData() {
    return null;
  }

  getDefaultOptions() {
    return {}
  }

  static asFunction() {
    return (...args) => new this(...args).render();
  }
}
